$(function (){
   let customPlotLines = [];
   let chart21Width = $('#chart-2-1').width();
   let resizedFinished;
   let section = $('.section-2-1');
   let chartContainer = section.find('.chart-container');

   function chartCountHeight(){
      var chartWidth = chartContainer.width();
      var chartHeight = 0;
      if (chartWidth < 500) {
         chartHeight = chartWidth;
      }
      if (chartWidth < 400) {
         chartHeight = chartWidth * 1.2;
      } else {
         chartHeight = chartWidth * 0.9;
      }

      chart21.yAxis[0].update({
         height: chartHeight - 180,
      });
      chart21.xAxis[0].update({
         height: chartHeight,
      })
      chart21.setSize(chartWidth, chartHeight);
   }

   $(window).on('resize', function () {
      clearTimeout(resizedFinished);
      resizedFinished = setTimeout(function () {
         chartCountHeight();
      }, 250);
   });


   let chart21 = Highcharts.chart('chart-2-1', {
      // $('#chart-2-2').highcharts({
      // chart = new Highcharts.chart({
      chart  : {
         type           : 'line',
         backgroundColor: 'transparent',
         height         : 500,
         events         : {
            load  : function () {
               drawPlotLines(this);
            },
            redraw: function () {
               drawPlotLines(this);
            },
         },
         marginLeft     : 80,
      },
      credits: false,
      title  : {
         text   : '<span style="text-align: right">'+ $('#topik-2-1 .y-axis').html() +'</span>',
         align  : 'left',
         useHTML: true,
         style  : {
            fontFamily: 'Inter',
            fontSize  : '12px',
            lineHeight: '16px',
            color     : 'rgba(255,255,255,0.6)',
         }
      },
      xAxis  : {
         title            : null,
         lineWidth        : 0,
         gridLineColor    : '#7C7C7C',
         gridLineWidth    : 0,
         gridLineDashStyle: 'longdash',
         tickLength       : 0,
         // offset           : 20,
         height           : 500,
         offset           : -140,
         categories       : [2016, 2017, 2018, 2019, 2020],
         crosshair        : {
            color: 'rgba(255,255,255,0.1)',
         },
         labels           : {
            style: {
               fontFamily: 'Inter',
               fontSize  : '18px',
               color     : '#FFFFFF',
            }
         },
         events           : {
            afterSetExtremes: function () {
               this.chart.tooltip.crosshairs = [];
               this.chart.tooltip.crosshairs.width = (this.chart.width / (this.series[0].points.length - 1));
            }
         }
      },
      yAxis      : {
         title        : null,
         lineWidth    : 0,
         gridLineColor: 'transparent',
         tickLength   : 0,
         tickAmount   : 4,
         offset       : 0,
         height       : 320,
         min          : 20,
         max          : 80,
         labels       : {
            style: {
               fontFamily: 'Inter',
               fontSize  : '18px',
               color     : '#FFFFFF',
            }
         }
      },
      legend     : {
         enabled: false
      },
      tooltip    : {
         backgroundColor: '#FFFFFF',
         borderColor    : 'transparent',
         padding        : 0,
         borderRadius   : 12,
         distance       : 35,
         useHTML        : true,
         formatter      : function () {
            if (this.point.hideTooltip) {
               return false;
            }
            return "" + this.y + "";
         },
      },
      plotOptions: {
         series: {
            dataLabels: {
               backgroundColor: 'transparent',
               borderColor    : 'transparent',
               padding        : 0,
               enabled        : true,
               borderRadius   : 22,
               distance       : 35,
               useHTML        : true,
               // y              : -70,
               // shape: 'callout'
            }
         }
      },
      style      : {
         fontFamily: 'Inter'
      },
      series     : [{
         name     : 'Index ketahanan pangan',
         data     : [
            {
               y     : 50.6,
               marker: {
                  fillColor: '#FFFFFF',
                  lineColor: '#f16521',
                  states   : {
                     hover: {
                        fillColor: '#f16521',
                        lineColor: '#FFFFFF',
                     }
                  }
               }
            },
            {
               y: 51.3,
            },
            {
               y     : 54.8,
               marker: {
                  fillColor: '#FFFFFF',
                  lineColor: '#f16521',
                  states   : {
                     hover: {
                        fillColor: '#f16521',
                        lineColor: '#FFFFFF',
                     }
                  }
               }
            },
            {
               y          : 62.6,
            },
            {
               y     : 59.5,
               marker: {
                  fillColor: '#FFFFFF',
                  lineColor: '#f16521',
                  states   : {
                     hover: {
                        fillColor: '#f16521',
                        lineColor: '#FFFFFF',
                     }
                  }
               },
               dataLabels : {
                  className: 'highlight',
               },
               hideTooltip: true,
            },
         ],
         lineColor: '#FFFFFF',

         marker: {
            fillColor: '#FFFFFF',
            lineColor: '#FFCE20',
            radius   : 6,
            lineWidth: 3,
            states   : {
               hover: {
                  fillColor : '#FFCE20',
                  lineColor : '#FFFFFF',
                  radiusPlus: 0,
                  radius    : 6,
                  lineWidth : 4,
               }
            }
         }
      }],

      responsive: {
         rules: [{
            condition   : {
               maxWidth: 400
            },
            chartOptions: {
               chart: {
                  marginLeft     : 40,
               },
               title: {
                  text: '<span style="text-align: left">'+ $('#topik-2-1 .y-axis').html() +'</span>',
               },
               xAxis: {
                  labels       : {
                     style: {
                        fontSize: '16px'
                     }
                  }
               },
               yAxis: {
                  labels       : {
                     style: {
                        fontSize: '16px'
                     }
                  }
               }
            }
         }]
      }
   });

   function drawPlotLines(chart) {
      let xAxis = chart.xAxis[0],
          yAxis = chart.yAxis[0],
          xValue = 0,
          yStart = yAxis.toPixels(yAxis.min),
          yEnd = yAxis.toPixels(yAxis.max);

      if (customPlotLines.length) {
         customPlotLines.forEach(function(customPlotLine){
            customPlotLine.destroy();
         })
      }

      for (i = 0; i < chart.xAxis[0].categories.length; i++) {
         xValue = xAxis.toPixels(chart.series[0].xData[i]);
         customPlotLines[i] = chart.renderer.path(['M', xValue, yStart, 'L', xValue, yEnd])
             .attr({
                'stroke-width'    : 2,
                'stroke-dasharray': '8,8',
                stroke            : '#7C7C7C'
             })
             .add();
      }
   }

   chartCountHeight();
});